var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChart = function SvgChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 156,
    height: 156,
    fill: "none",
    viewBox: "0 0 155 155"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chart_svg__a)",
    d: "M155.248 134.278H0V82.299l43.125-64.973 60.374 30.32L155.248 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chart_svg__b)",
    d: "M155.248 155.937H0v-43.316l43.125-34.652 60.374 8.663 51.749-38.984z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__a",
    x1: 0,
    x2: 155.248,
    y1: 67.139,
    y2: 67.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0042E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chart_svg__b",
    x1: 77.624,
    x2: 77.624,
    y1: 47.648,
    y2: 155.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43D7EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EB8EC"
  })))));
};
export default SvgChart;